import Vue from 'vue'
export default Vue.extend({
  name: 'app',
  data () {
    return {
      mainContentTopColor: 'background-purple'
    }
  },
  methods: {
  }

})



// WEBPACK FOOTER //
// ./src/App.ts